import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../core/i18n';
import { Common } from '../../../core/common';
import { IAction, IAppState } from '../../../models/action/core';
import { connect } from 'react-redux';
import { IOpenEndedProps } from '../../../models/components/add-question';
import { BaseFields } from './baseFields';

const T = Translator.create();
const _logger = Log.create('Open Ended');
let _common: Common;
class OpenEnded extends Component<IOpenEndedProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public render() {
        return (
            <div id="st3" className="col">
                <BaseFields formik={this.props.formik} isFromMadlen={this.props.isFromMadlen} fileInputKey={this.props.fileInputKey} />
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IOpenEndedProps): IOpenEndedProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IOpenEndedProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const COpenEnded = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(OpenEnded);

export default COpenEnded;
